const PIXEL = "'Press Start 2P', monospace";

interface Props {
  /** Wordmark font size in px. */
  size?: number;
  /** Set false to render only the caution-stripe block (compact headers). */
  wordmark?: boolean;
}

/**
 * The FOUNDR-XI lockup: the caution-stripe block used in the in-app Topbar
 * plus a glowing pixel wordmark. One logo, everywhere.
 */
export default function Logo({ size = 13, wordmark = true }: Props) {
  const stripeH = Math.round(size * 1.9);
  const stripeW = Math.max(2, Math.round(size / 4));
  // In-app chrome sets --c-accent per theme; the landing has no data-theme so
  // the caution-yellow fallback keeps the original lockup there.
  const accent = 'var(--c-accent, #f0c000)';
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: Math.round(size * 0.8), color: accent }}>
      <span aria-hidden="true" style={{ display: 'flex', overflow: 'hidden' }}>
        {Array.from({ length: 8 }).map((_, i) => (
          <span
            key={i}
            style={{
              width: stripeW,
              height: stripeH,
              background: i % 2 === 0 ? accent : '#131a15',
              transform: 'skewX(-18deg)',
            }}
          />
        ))}
      </span>
      {wordmark && (
        <span
          style={{
            fontFamily: PIXEL,
            fontSize: size,
            letterSpacing: 1,
            textShadow: '0 0 10px color-mix(in srgb, currentColor 55%, transparent)',
            whiteSpace: 'nowrap',
          }}
        >
          FOUNDR-XI
        </span>
      )}
    </span>
  );
}
